import { render, staticRenderFns } from "./OperateDeta.vue?vue&type=template&id=ca102b2e&scoped=true"
import script from "./OperateDeta.vue?vue&type=script&lang=js"
export * from "./OperateDeta.vue?vue&type=script&lang=js"
import style0 from "./OperateDeta.vue?vue&type=style&index=0&id=ca102b2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca102b2e",
  null
  
)

export default component.exports